import React from "react";
import pdfFile from "../pdfs/Tipkit-RoomAttendnat-spanish.pdf";
import PdfViewer from "../comman/PdfViewer";

const AttendantGuidInSpanish = () => {
    return <PdfViewer pdfFile={pdfFile} />;
};

export default AttendantGuidInSpanish;
